import type React from "react";

function SubSample(): React.ReactNode {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: initial biome migration
    <svg
      version="1.1"
      x="0px"
      y="0px"
      style={{ height: 83, opacity: 0.7, position: "absolute", bottom: -28, width: 83 }}
      width="200px"
      height="200px"
      viewBox="0 0 200 200"
      enableBackground="new 0 0 200 200"
    >
      <g>
        <g>
          <path
            id="XMLID_116_"
            fill="#FFFFFF"
            d="M144.04,164.033L144.04,164.033c-5.876,0-10.641-4.764-10.641-10.639V69.954h21.28v83.441
			C154.68,159.27,149.916,164.033,144.04,164.033z"
          />
          <path
            id="XMLID_114_"
            fill="#E3ECEA"
            d="M156.359,60.994h-24.64c-2.475,0-4.479,2.006-4.479,4.48l0,0
			c0,2.474,2.006,4.479,4.479,4.479h24.64c2.475,0,4.48-2.006,4.48-4.479l0,0C160.84,63,158.834,60.994,156.359,60.994z"
          />

          <path
            id="XMLID_60_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M144.04,164.033L144.04,164.033c-5.876,0-10.641-4.764-10.641-10.639V69.954h21.28v83.441
			C154.68,159.27,149.916,164.033,144.04,164.033z"
          />

          <path
            id="XMLID_58_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M156.359,60.994h-24.64c-2.475,0-4.479,2.006-4.479,4.48l0,0c0,2.474,2.006,4.479,4.479,4.479h24.64
			c2.475,0,4.48-2.006,4.48-4.479l0,0C160.84,63,158.834,60.994,156.359,60.994z"
          />
          <path
            id="XMLID_113_"
            fill="#99BBB2"
            d="M138.439,123.154v30.24c0,3.088,2.513,5.6,5.602,5.6c3.088,0,5.6-2.512,5.6-5.6v-30.24
			H138.439z"
          />

          <path
            id="XMLID_107_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M138.439,123.154v30.24c0,3.088,2.513,5.6,5.602,5.6c3.088,0,5.6-2.512,5.6-5.6v-30.24H138.439z"
          />
          <circle id="XMLID_143_" fill="#99BBB2" cx="133.443" cy="38.784" r="2.118" />
          <circle id="XMLID_145_" fill="#99BBB2" cx="141.213" cy="48.54" r="1.788" />
          <circle id="XMLID_148_" fill="#99BBB2" cx="150.479" cy="20.86" r="4.042" />
          <circle id="XMLID_149_" fill="#99BBB2" cx="148.168" cy="37.437" r="3.465" />

          <circle
            id="XMLID_129_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="133.443"
            cy="38.784"
            r="2.118"
          />

          <circle
            id="XMLID_128_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="141.213"
            cy="48.54"
            r="1.788"
          />

          <circle
            id="XMLID_127_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="140.139"
            cy="29.908"
            r="1.155"
          />

          <circle
            id="XMLID_119_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="150.479"
            cy="20.86"
            r="4.042"
          />

          <circle
            id="XMLID_117_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="148.168"
            cy="37.437"
            r="3.465"
          />
          <circle id="XMLID_140_" fill="#99BBB2" cx="142.084" cy="100.987" r="4.06" />

          <circle
            id="XMLID_134_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="142.084"
            cy="100.987"
            r="4.06"
          />
          <circle id="XMLID_153_" fill="#99BBB2" cx="145.58" cy="114.8" r="1.728" />

          <circle
            id="XMLID_151_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="145.58"
            cy="114.8"
            r="1.728"
          />
          <circle id="XMLID_165_" fill="#99BBB2" cx="147.871" cy="77.813" r="2.4" />

          <circle
            id="XMLID_162_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="147.871"
            cy="77.813"
            r="2.4"
          />
          <circle id="XMLID_169_" fill="#BED3CE" cx="139.425" cy="74.031" r="0.907" />

          <circle
            id="XMLID_167_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="139.425"
            cy="74.031"
            r="0.907"
          />
          <circle id="XMLID_160_" fill="#6B9C8F" cx="144.731" cy="131.872" r="0.878" />
          <circle id="XMLID_156_" fill="#6B9C8F" cx="139.91" cy="141.284" r="1.47" />
          <circle id="XMLID_158_" fill="#6B9C8F" cx="146.452" cy="148.562" r="2.104" />
          <circle id="XMLID_159_" fill="#6B9C8F" cx="143.331" cy="129.282" r="0.317" />
        </g>
        <g>
          <rect id="XMLID_109_" x="10.342" y="172.994" fill="#D3E1DD" width="179.199" height="9.521" />

          <rect
            id="XMLID_57_"
            x="10.342"
            y="172.994"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            width="179.199"
            height="9.521"
          />
        </g>
        <rect id="XMLID_106_" x="19.375" y="88.994" fill="#E4EDEB" width="5.602" height="84" />

        <rect
          id="XMLID_55_"
          x="19.375"
          y="88.994"
          fill="none"
          stroke="#6B9C8F"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          width="5.602"
          height="84"
        />
        <rect id="XMLID_108_" x="174.908" y="88.994" fill="#E4EDEB" width="5.602" height="84" />

        <rect
          id="XMLID_53_"
          x="174.908"
          y="88.994"
          fill="none"
          stroke="#6B9C8F"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          width="5.602"
          height="84"
        />
        <g>
          <path
            id="XMLID_110_"
            fill="#FFFFFF"
            d="M99.942,164.033L99.942,164.033c-5.876,0-10.641-4.764-10.641-10.639V69.954h21.28v83.441
			C110.582,159.27,105.818,164.033,99.942,164.033z"
          />

          <path
            id="XMLID_32_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M99.942,164.033L99.942,164.033c-5.876,0-10.641-4.764-10.641-10.639V69.954h21.28v83.441
			C110.582,159.27,105.818,164.033,99.942,164.033z"
          />
          <rect id="XMLID_112_" x="91.122" y="49.98" fill="#AFCAC3" width="17.641" height="19.974" />

          <rect
            id="XMLID_111_"
            x="91.122"
            y="49.98"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            width="17.641"
            height="19.974"
          />
          <path
            id="XMLID_23_"
            fill="#E3ECEA"
            d="M112.262,60.994H87.621c-2.474,0-4.479,2.006-4.479,4.48l0,0
			c0,2.474,2.007,4.479,4.479,4.479h24.641c2.475,0,4.479-2.006,4.479-4.479l0,0C116.742,63,114.736,60.994,112.262,60.994z"
          />

          <path
            id="XMLID_21_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M112.262,60.994H87.621c-2.474,0-4.479,2.006-4.479,4.48l0,0c0,2.474,2.007,4.479,4.479,4.479h24.641
			c2.475,0,4.479-2.006,4.479-4.479l0,0C116.742,63,114.736,60.994,112.262,60.994z"
          />
          <path
            id="XMLID_104_"
            fill="#97BAB1"
            d="M94.342,136.121v17.273c0,3.088,2.513,5.6,5.601,5.6s5.601-2.512,5.601-5.6v-17.273
			H94.342z"
          />

          <path
            id="XMLID_125_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M94.342,136.121v17.273c0,3.088,2.513,5.6,5.601,5.6s5.601-2.512,5.601-5.6v-17.273H94.342z"
          />
          <circle id="XMLID_20_" fill="#97BAB1" cx="98.052" cy="121.475" r="1.68" />

          <circle
            id="XMLID_18_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="98.052"
            cy="121.475"
            r="1.68"
          />
          <circle id="XMLID_122_" fill="#97BAB1" cx="100.852" cy="104.534" r="2.8" />

          <circle
            id="XMLID_137_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="100.852"
            cy="104.534"
            r="2.8"
          />
          <circle id="XMLID_147_" fill="#97BAB1" cx="101.225" cy="129.874" r="1.12" />

          <circle
            id="XMLID_144_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="101.225"
            cy="129.874"
            r="1.12"
          />
          <circle id="XMLID_139_" fill="#6B9C8F" cx="99.057" cy="148.563" r="1.005" />
          <circle id="XMLID_142_" fill="#6B9C8F" cx="99.617" cy="142.869" r="1.607" />
        </g>
        <g>
          <rect id="XMLID_15_" x="47.024" y="49.98" fill="#AFCAC3" width="17.64" height="19.974" />

          <rect
            id="XMLID_93_"
            x="47.024"
            y="49.98"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            width="17.64"
            height="19.974"
          />
          <path
            id="XMLID_96_"
            fill="#E3ECEA"
            d="M68.164,60.994h-24.64c-2.475,0-4.479,2.006-4.479,4.48l0,0
			c0,2.474,2.006,4.479,4.479,4.479h24.64c2.476,0,4.48-2.006,4.48-4.479l0,0C72.645,63,70.639,60.994,68.164,60.994z"
          />

          <path
            id="XMLID_19_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M68.164,60.994h-24.64c-2.475,0-4.479,2.006-4.479,4.48l0,0c0,2.474,2.006,4.479,4.479,4.479h24.64c2.476,0,4.48-2.006,4.48-4.479
			l0,0C72.645,63,70.639,60.994,68.164,60.994z"
          />
          <path
            id="XMLID_7_"
            fill="#FFFFFF"
            d="M55.845,164.033L55.845,164.033c-5.876,0-10.642-4.764-10.642-10.639V69.954h21.28v83.441
			C66.484,159.27,61.721,164.033,55.845,164.033z"
          />

          <path
            id="XMLID_17_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M55.845,164.033L55.845,164.033c-5.876,0-10.642-4.764-10.642-10.639V69.954h21.28v83.441
			C66.484,159.27,61.721,164.033,55.845,164.033z"
          />
          <path
            id="XMLID_1_"
            fill="#D1E0DC"
            d="M50.244,108.781v44.613c0,3.088,2.514,5.6,5.602,5.6c3.087,0,5.6-2.512,5.6-5.6v-44.613
			H50.244z"
          />

          <path
            id="XMLID_115_"
            fill="none"
            stroke="#6B9C8F"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M50.244,108.781v44.613c0,3.088,2.514,5.6,5.602,5.6c3.087,0,5.6-2.512,5.6-5.6v-44.613H50.244z"
          />
          <circle id="XMLID_171_" fill="#6B9C8F" cx="54.236" cy="128.754" r="1.607" />
          <circle id="XMLID_174_" fill="#6B9C8F" cx="53.604" cy="99.821" r="1.083" />
          <circle id="XMLID_173_" fill="#6B9C8F" cx="57.453" cy="115.387" r="0.699" />
          <circle id="XMLID_172_" fill="#6B9C8F" cx="57.453" cy="139.651" r="0.675" />
        </g>
        <rect id="XMLID_101_" x="10.342" y="84.514" fill="#D3E1DD" width="179.199" height="4.479" />

        <rect
          id="XMLID_16_"
          x="10.342"
          y="84.514"
          fill="none"
          stroke="#6B9C8F"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          width="179.199"
          height="4.479"
        />
      </g>
    </svg>
  );
}

export default SubSample;
